import { GetServerSideProps } from "next";
import { handleRequestError } from "~/utils/rollbar";
import type { StoreCart as StoreCartType } from "~/shared-types";
import { SectionHeading } from "~/components/SectionHeading";
import { withIronSessionSsr } from "iron-session/next";
import { sessionOptions } from "~/utils/apiWithCart";
import decompressCart from "~/utils/decompressCart";
import { StoreCart } from "./StoreCart";
import { getStoreCarts } from "~/utils/getStoreCarts";
import { HTMLLevels } from "~/components/Heading";
import MultipleCarts from "./MultipleCarts";
import { EmptyStateMessage } from "~/components/Backroom/EmptyStateMessage";
import Link from "next/link";
import { getRoute } from "~/utils/getRoute";

type CartPageProps = {
  carts: StoreCartType[];
};

export const getServerSideProps: GetServerSideProps<CartPageProps> =
  withIronSessionSsr(async (context) => {
    const sessionCart = decompressCart(context.req.session.cart);

    const carts = await getStoreCarts(sessionCart).catch(
      handleRequestError(context.req, [])
    );

    return { props: { carts } };
  }, sessionOptions);

export default function CartPage({ carts }: CartPageProps) {
  const cartAmount = carts.length;

  if (cartAmount === 0) {
    return (
      <>
        <SectionHeading>
          <SectionHeading.Title>Din kurv er tom</SectionHeading.Title>
        </SectionHeading>

        <EmptyStateMessage
          iconName="cart"
          title="Du har ingen produkter i kurven"
          text={
            <Link className="underline" href={getRoute("/root")}>
              Klik her for at gå til forsiden.
            </Link>
          }
        />
      </>
    );
  }
  const hasMultipleCarts = cartAmount > 1;
  const title = hasMultipleCarts ? `Du har ${cartAmount} kurve` : "Din kurv";
  return (
    <>
      <SectionHeading>
        <SectionHeading.Title level={HTMLLevels.h1} className="mb-20">
          {title}
        </SectionHeading.Title>
        {hasMultipleCarts && <MultipleCarts cartAmount={cartAmount} />}
        {carts.map((cart) => (
          <StoreCart cart={cart} key={cart.store?.id} />
        ))}
      </SectionHeading>
    </>
  );
}
